import { Controller } from "@hotwired/stimulus"

// Expand/collapse for one folder in the Files rail's tree (TASK-158.2).
//
// The SERVER renders the open state — the folder you are looking at and its
// ancestors come back expanded — so this controller only handles what the
// member does by hand. There is nothing to apply on connect, which is why a
// Turbo navigation never flashes the wrong tree.
export default class extends Controller {
  static targets = ["children", "chevron"]
  static values = { expanded: Boolean }

  toggle(event) {
    event.preventDefault()
    // On mobile the tree lives inside the dock's slide-up panel, which closes
    // on any click that reaches it. Expanding a folder is not leaving.
    event.stopPropagation()

    this.expandedValue = !this.expandedValue
  }

  expandedValueChanged() {
    if (!this.hasChildrenTarget) return

    this.childrenTarget.classList.toggle("hidden", !this.expandedValue)

    if (this.hasChevronTarget) {
      this.chevronTarget.setAttribute("aria-expanded", this.expandedValue)
      this.chevronTarget.querySelector("svg")?.classList.toggle("rotate-90", this.expandedValue)
    }
  }
}
